import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import {
  clearRequest,
  deleteSprint,
  denyRequest,
  getPossibleClasses,
  getRequests,
  getSchool,
  getSprintEvaluations,
  getSprintGrades,
  getSprints,
  getTeacherAssignments,
  getTeacherClasses,
  getTeacherEvaluations,
  getTeacherStudents,
  grantRequest,
  releaseSprint,
  releaseStudentReviewEvaluations,
  setAssignment,
  setClass,
  setClassEvalsSprintAndAssignments,
  setClassIndex,
  setCurrentSprint,
  setLoadingAssets,
  setSprint,
} from "../../redux";
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import AssignmentTile from './AssignmentTile';
import Tile from '../Components/Tile';
import '../Components/dashboard.css';
import { useNavigate } from 'react-router-dom';

function Teacher (props) {
    const navigate = useNavigate();

    const {
        // TODO selectors
        user,
        classIndex,
        teacherClasses,
        teacherEvaluations,
        assignments,
        teacherStudents,
        loadingAssets,
        sprints,
        // actions
        clearRequest,
        deleteSprint,
        denyRequest,
        getPossibleClasses,
        getRequests,
        getSchool,
        getSprintEvaluations,
        getSprintGrades,
        getTeacherAssignments,
        getTeacherClasses,
        getTeacherEvaluations,
        getTeacherStudents,
        grantRequest,
        releaseSprint,
        releaseStudentReviewEvaluations,
        setAssignment,
        setClass,
        setClassEvalsSprintAndAssignments,
        setClassIndex,
        setCurrentSprint,
        setLoadingAssets,
        setSprint,
        getSprints,
    } = props;

    const [currentClassIndex, setCurrentClassIndex] = useState(classIndex);
    const [isViewingClassMenu, setIsViewingClassMenu] = useState(false);
    const [message, setMessage] = useState("");
    const [requestMessage, setRequestMessage] = useState("");
    const [loading, setLoading] = useState(true);
    const [showDialog, setShowDialog] = useState(false);
    const currentRequests = props.requests;
    const requests = currentRequests.filter(request => request.teacher === user._id);

    useEffect(() => {
        window.scrollTo(0, 0);
        setLoadingAssets('teacherClasses');
        setLoadingAssets('gradingEvaluations');
        getTeacherAssignments(user._id);
        getTeacherClasses(user._id);
        getTeacherStudents(user._id);
        getSchool(user.school);
        getTeacherEvaluations(user._id);
        // Fetch sprints for all classes this teacher can access.
        getSprints(user._id);
        getPossibleClasses(user.school);
        setClassIndex(classIndex);
        getRequests();
        setLoading(false);
    }, []);

    const manageStudents = () => {
        setClassIndex(currentClassIndex);
        navigate("/manage/students");
    }

    const manageClasses = () => {
        navigate("/manage/classes");
    }

    const toggleClassMenu = () => {
        setIsViewingClassMenu(!isViewingClassMenu);
        setMessage("");
        setRequestMessage("");
    }

    const getMappedClassOptions = () => {
        return teacherClasses !== undefined ? teacherClasses
                  .map((classObject, index) => {
                      return (
                          <MenuItem
                              key={index + classObject.name}
                              value={classObject.name}
                              primaryText={classObject.name}
                              id="class"
                          />
                      );
                  })
                  : null;
    }

    const setAssignmentAndRedirect = (assignment) => {
        setClassIndex(currentClassIndex);
        setAssignment(assignment);
        navigate("/assignment/edit");
    }

    const setClassAssignmentNewAndRedirect = (classObject) => {
        setClassIndex(currentClassIndex);
        setClass(classObject);
        navigate("/assignment/new");
    }

    const setClassEditAndRedirect = (classObject, sprint) => {
        setLoadingAssets('teacherClasses');
        setLoadingAssets('gradingEvaluations');
        setClassIndex(currentClassIndex);
        setClassEvalsSprintAndAssignments(classObject, sprint);
        navigate("/teacher/graded");
    }

    const setClassAndRedirect = (classObject, sprint) => {
        setLoadingAssets('teacherClasses');
        setLoadingAssets('gradingEvaluations');
        setClassIndex(currentClassIndex);
        setClassEvalsSprintAndAssignments(classObject, sprint);
        navigate("/teacher/grading");
    }

    const setClassSprintAndRedirect = (classObject) => {
        setClassIndex(currentClassIndex);
        setClass(classObject);
        navigate("/sprint/new");
    }

    const setSprintAndRedirect = (sprint) => {
        setClassIndex(currentClassIndex);
        setSprint(sprint);
        getSprintEvaluations(sprint._id);
        navigate("/teacher/reviews");
    }

    const setSprintGradesAndRedirect = (sprint) => {
        setClassIndex(currentClassIndex);
        setSprint(sprint);
        getSprintGrades(sprint._id);
        navigate("/teacher/grades");
    }

    const handleRelease = (assignment, assignments, evaluations, event) => {
        event.stopPropagation();
        releaseStudentReviewEvaluations(assignment._id, assignments, evaluations);
        setMessage(`Your feedback for ${assignment.name} has been released.`);
        setRequestMessage("");
    }

    const getMappedAssignments = (assignments, classObject) => {
        let date;
        if (assignments.length === 0) {
            return <h5 style={{marginLeft: "20px", marginTop: 0, marginBottom: "0px"}}>No assignments exist for this sprint.</h5>;
        }
        return assignments.map((assignment, index) => {
                date = assignment.dueDate.slice(5, 10).replace("-", "/");
                if (date[0] === "0") {
                    date = date.slice(1);
                }
                return (
                    <div className="tileContainer" key={index + "assignmentContainer"}>
                        <AssignmentTile
                            key={index + "assignment"}
                            number={assignment.name}
                            name={assignment.status}
                            status={"Release Grades"}
                            dueDate={`Due ${date}`}
                            grade={"Click to Edit"}
                            handleClick={() => setAssignmentAndRedirect(assignment)}
                            handleRelease={(event) => handleRelease(assignment, assignments, teacherEvaluations, event)}
                        />
                    </div>
                );
        });
    }

    const getMappedSprintAssignments = (assignments) => {
        return assignments.map((assignment, index) => {
            return (
                <div className="greySprintTileBackground" key={index + "sprintAssignment"}>
                    <div className="sprintTileContainer">
                        <div className="sprintTile">
                            <p>{assignment.name}</p>
                        </div>
                    </div>
                </div>
            );
        });
    }

    const getMappedReviews = (evaluations, classObject, sprint) => {
        if (evaluations.length === 0) {
            return <h5 style={{marginLeft: "20px", marginTop: 0, marginBottom: "0px"}}>There are not any reviews left to grade.</h5>;
        }

        const evaluation = evaluations[0];
        const assignment = assignments.find(assignment => assignment._id === evaluation.assignment) || {name: "Assignment"};
        const splittedName = evaluation.nameOfReviewingStudent.split(",");
        const classAndRedirect = () => setClassAndRedirect(classObject, sprint);
        const status = evaluation.status === "StudentSubmitted" ? "Submitted" : "Resubmitted";

        if (evaluations.length === 1) {
            return (
                <div className="tileContainer">
                    <Tile
                        number={`${splittedName[1]} ${splittedName[0][0]}.`}
                        name={assignment.name}
                        status={status}
                        handleClick={classAndRedirect}
                    />
                </div>
            );
        } else if (evaluations.length === 2) {
            return (
                <div className="tileContainer">
                    <Tile
                        number={`${splittedName[1]} ${splittedName[0][0]}.`}
                        name={assignment.name}
                        status={status}
                        handleClick={classAndRedirect}
                    />
                    <div className="tileShadow1"></div>
                </div>
            );
        } else {
            return (
                <div className="tileContainer">
                    <Tile
                        number={`${splittedName[1]} ${splittedName[0][0]}.`}
                        name={assignment.name}
                        status={status}
                        handleClick={classAndRedirect}
                    />
                    <div className="tileShadow1"></div>
                    <div className="tileShadow2"></div>
                </div>
            );
        }
    }

    const getMappedReports = (classObject, releasedClassSprints) => {
        let evaluations = teacherEvaluations && teacherEvaluations
            .filter(evaluation => evaluation.class === classObject._id);
        let sprintEvaluations;
        return releasedClassSprints.map((sprint, index) => {
            sprintEvaluations = evaluations.filter(evaluation => evaluation.sprint === sprint._id).length;
            return (
                <div className="tileContainer" key={index + "sprintContainer"}>
                    <Tile
                        key={index + "sprint"}
                        number={sprint.name}
                        name={`${sprintEvaluations} Reviews`}
                        status={"View the report"}
                        handleClick={() => setSprintAndRedirect(sprint)}
                    />
                </div>
            )
        });
    }

    const getMappedGrades = (classObject, releasedClassSprints) => {
        let classStudents = teacherStudents.filter(student => student.classes.some(classId => classObject._id === classId));
        return releasedClassSprints.map((sprint, index) => {
            return (
                <div className="tileContainer" key={index + "sprintContainer"}>
                    <Tile
                        key={index + "sprint"}
                        number={sprint.name}
                        name={`${classStudents.length} Students`}
                        status={"View student grades"}
                        handleClick={() => setSprintGradesAndRedirect(sprint)}
                    />
                </div>
            )
        });
    }

    const getMappedPermissions = (permissions) => {
        let name;
        return permissions.map((request, index) => {
            name = `${request.firstName} ${request.lastName}`;
            return (
                <div className="request" key={index + "permissionContainer"}>
                    <h4 className="name">
                        <span>{`${name} (${request.email})`}</span>
                    </h4>
                    <h4 className="class">
                        requested to join <span>{request.className}</span> as an instructor.
                    </h4>
                    <button className="actionButton" style={{marginRight: "20px"}} onClick={() => grantAccess(request, name)}>
                        Allow
                    </button>
                    <button className="actionButton" onClick={() => denyAccess(request._id, name)}>
                        Deny
                    </button>
                </div>
            );
        })
    }

    const getMappedRequests = (requests) => {
        return requests.map((request, index) => {
            return (
                <div className="request" key={index + "requestContainer"}>
                    {request.status === "Denied" ?
                        <div>
                            <h4 className="status">Your request to join <span>{request.className}</span> was denied.</h4>
                            <button className="actionButton" onClick={() => clearAccessRequest(request._id)}>
                                Clear
                            </button>
                        </div>
                        :
                        <div>
                            <h4 className="status">Your request to join <span>{request.className}</span> is pending.</h4>
                            <button className="actionButton" onClick={() => clearAccessRequest(request._id)}>
                                Undo
                            </button>
                        </div>
                    }
                </div>
            );
        })
    }

    const grantAccess = (request, name) => {
        grantRequest(request, currentRequests, teacherClasses);
        setRequestMessage(`${name} now can access the ${request.className} course.`);
        setMessage("");
    }

    const denyAccess = (requestId, name) => {
        denyRequest(requestId, currentRequests)
        setRequestMessage(`${name}'s request has been denied.`);
        setMessage("");
    }

    const clearAccessRequest = (requestId) => {
        clearRequest(requestId, currentRequests)
    }

    const handleDropdownChange = (event, menuItemIndex, value) => {
        const selectedName =
            (typeof value === "string" && value.trim()) ||
            (event && event.target && event.target.innerText && event.target.innerText.trim()) ||
            "";
        const i = teacherClasses.findIndex(
            (classObject) => (classObject.name || "").trim() === selectedName
        );
        if (i >= 0) {
            setCurrentClassIndex(i);
            setClassIndex(i);
            // Keep redux `classObject` in sync with the dropdown selection.
            setClass(teacherClasses[i]);
        }
        setMessage("");
        setRequestMessage("");
    }

    const handleSprintDropdownChange = (sprintId, classObjectId) => {
        setCurrentSprint(sprintId, classObjectId, teacherClasses);
    }

    const mapClassSprintOptions = (classSprints, classObjectId) => {
        return classSprints && classSprints
                  .map((sprint, index) => {
                      return (
                          <MenuItem
                              key={index + sprint.name}
                              value={sprint.name}
                              primaryText={sprint.name}
                              onClick={() => handleSprintDropdownChange(sprint._id, classObjectId)}
                          />
                      );
                  });
    }


    if (loading || loadingAssets.teacherClasses || loadingAssets.gradingEvaluations) {
        return (
            <div className="dashboard">
                <div className="classElement">
                    <div className="classChoice">
                        <SelectField
                            name="class"
                            value='Class'
                            onChange={handleDropdownChange}
                            iconStyle={{ paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px" }}
                            style={{ borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px" }}
                            labelStyle={{ color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px" }}
                            underlineStyle={{ border: "none" }}
                        >
                            {getMappedClassOptions()}
                        </SelectField>
                    </div>
                    {isViewingClassMenu &&
                        <div className="classMenuWindow">
                            <h4 onClick={manageClasses}>Manage Classes</h4>
                            <h4 onClick={manageStudents}>Manage Students</h4>
                        </div>
                    }
                    <div className="classMenu" onClick={toggleClassMenu}>
                        <i className="fa fa-ellipsis-v" style={{ textAlign: "center", fontSize: "16px", color: "rgba(0, 0, 0, 0.87)" }}></i>
                    </div>
                </div>
                <div className="loading">
                    <img src={"/loading.svg"} alt="Loading..." />
                </div>
            </div>
        );
    }

    let reviewsTotal = 0;
    let reviewsText = "You have graded all of this class's reviews.";

    const classObject = (Object.keys(props.classObject).length
      ? props.classObject
      : null) ||
      teacherClasses[currentClassIndex] || { name: "" };

    const classIds = user.classes;
    const permissions = currentRequests
        .filter(request => request.status !== "Denied")
        .filter(request => {
            for (let i = 0; i < classIds.length; i++) {
                if (classIds[i] === request.class) {
                    return true;
                }
            }
            return false;
        });
    if (permissions.length === 1) {
        reviewsText = `${reviewsText.slice(0, reviewsText.length - 1)} and ${permissions.length} instructor requested to join your classes.`
    } else if (permissions.length > 1) {
        reviewsText = `${reviewsText.slice(0, reviewsText.length - 1)} and ${permissions.length} instructors requested to join your classes.`
    }

    const filteredRequests = requests.filter(request => request.teacher === user._id);

    if (teacherClasses.length === 0) {
        return (
            <div className="dashboard">
                <div className="classElement">
                    <div className="classChoice">
                        <SelectField
                            name="class"
                            value={classObject.name}
                            onChange={handleDropdownChange}
                            iconStyle={{paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px"}}
                            style={{borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px"}}
                            labelStyle={{color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px"}}
                            underlineStyle={{border: "none"}}
                        >
                            {getMappedClassOptions()}
                        </SelectField>
                    </div>
                    {isViewingClassMenu &&
                        <div className="classMenuWindow">
                            <h4 onClick={manageClasses}>Manage Classes</h4>
                        </div>
                    }
                    <div className="classMenu" onClick={toggleClassMenu}>
                        <i className="fa fa-ellipsis-v" style={{textAlign: "center", fontSize: "16px", color: "rgba(0, 0, 0, 0.87)"}}></i>
                    </div>
                </div>
                <h1>Hi {user.firstName},</h1>
                <h2>
                    It looks like you're new here! First, start by creating a new class or requesting to join another teacher's class.
                    Click on the 3 dots in the top-right corner. Manage Classes should be on the menu. Click it and go from there!
                </h2>
                <h2>
                    Note that once you add yourself to another teacher's class, you must wait for them to grant you access to their class before you see it here.
                </h2>
                {permissions.length !== 0 &&
                    <div>
                        <h3 style={{marginBottom: "50px"}}>Permissions</h3>
                        <div className="requests">
                            {getMappedPermissions(permissions)}
                        </div>
                    </div>
                }
                {filteredRequests.length !== 0 &&
                    <div>
                        <h3 style={{marginBottom: "50px"}}>Requests</h3>
                        <div className="requests">
                            {getMappedRequests(filteredRequests)}
                        </div>
                    </div>
                }
                <p style={{marginTop: "50px", marginBottom: "-50px"}}>{requestMessage}</p>
            </div>
        );
    }


    let pinkBarStyle = {zIndex: 1, boxShadow: "0 6px 10px 0 rgba(0, 0, 0, 0.23), 0 1px 1px 0 rgba(0, 0, 0, 0.3)"}
    let greySprintBarStyle = {};

    const sprint = sprints.find(sprint => sprint._id === classObject.currentSprint);
    const hasSelectedSprint = Boolean(sprint && sprint._id);
    const classSprints = sprints.filter(sprint => sprint.class === classObject._id);

    const evaluations = teacherEvaluations && teacherEvaluations
        .filter(evaluation => evaluation.class === classObject._id);
    const filteredAssignments = assignments && assignments
        .filter(assignment => assignment.sprint === classObject.currentSprint)
        .sort((a, b) => {
            if (a.dueDate < b.dueDate) return -1;
            if (a.dueDate > b.dueDate) return 1;
            return 0;
        });


    let evaluationsToGrade;
    if (evaluations) {
        evaluationsToGrade = evaluations.filter(evaluation => evaluation.status === "StudentSubmitted" || evaluation.status === "StudentResubmitted" || evaluation.teacherGrade === undefined);
        reviewsTotal = evaluations.length;
        reviewsText = `There are ${evaluationsToGrade.length} reviews to grade.`
        pinkBarStyle.width = `${(reviewsTotal - evaluationsToGrade.length) / reviewsTotal * 100}%`;
    } else {
        pinkBarStyle.width = "0%";
    }

    if (filteredAssignments.length === 0) {
        greySprintBarStyle = {
            height: "45px",
            borderRadius: "8px",
            backgroundColor: "#e8e8e8",
            width: "100%",
            marginLeft: "0px"
        }
    }

    let noAssignmentStyle = {};
    if (!sprint) {
        noAssignmentStyle = {marginTop: "40px"}
    }

    const releasedClassSprints = classSprints.filter(sprint => sprint.status === "Released");

    return (
        <div className="dashboard">
            <div className="classElement">
                <div className="classChoice">
                    <SelectField
                        name="class"
                        value={classObject.name}
                        onChange={handleDropdownChange}
                        iconStyle={{paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px"}}
                        style={{borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px"}}
                        labelStyle={{color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px"}}
                        underlineStyle={{border: "none"}}
                    >
                        {getMappedClassOptions()}
                    </SelectField>
                </div>
                {isViewingClassMenu &&
                    <div className="classMenuWindow">
                        <h4 onClick={manageClasses}>Manage Classes</h4>
                        <h4 onClick={manageStudents}>Manage Students</h4>
                    </div>
                }
                <div className="classMenu" onClick={toggleClassMenu}>
                    <i className="fa fa-ellipsis-v" style={{textAlign: "center", fontSize: "16px", color: "rgba(0, 0, 0, 0.87)"}}></i>
                </div>
            </div>
            <h1>Hi {user.firstName},</h1>
            <h2>{reviewsText}</h2>
            <div className="greyBar" style={{zIndex: 0}}>
                <div className="pinkBar" style={{zIndex: 2, boxShadow: "0 0 0 0"}}>
                    <h4>Reviews Graded: {reviewsTotal - evaluationsToGrade.length}/{reviewsTotal}</h4>
                </div>
                <div className="pinkBar" style={pinkBarStyle}></div>
            </div>
            {permissions.length !== 0 &&
                <div>
                    <h3 style={{marginBottom: "50px"}}>Permissions</h3>
                    <div className="requests">
                        {getMappedPermissions(permissions)}
                    </div>
                </div>
            }
            {requests.length !== 0 &&
                <div>
                    <h3 style={{marginBottom: "50px"}}>Requests</h3>
                    <div className="requests">
                        {getMappedRequests(requests)}
                    </div>
                </div>
            }
            <p style={{marginTop: "50px", marginBottom: "-50px"}}>{requestMessage}</p>
            {filteredAssignments.length > 0 &&
                <div>
                    <div className="reviewHeaders">
                        <h3 className="left" style={noAssignmentStyle}>Reviews to Grade</h3>
                        <h3 className="right" style={noAssignmentStyle}><button to="/teacher/graded" className="link" onClick={() => setClassEditAndRedirect(classObject, sprint)}>View Graded Reviews</button></h3>
                    </div>
                    <div className="tiles">
                        {getMappedReviews(evaluationsToGrade, classObject, sprint)}
                    </div>
                </div>
            }
            <h3>Sprint</h3>
            {sprints && sprints.length !== 0 ?
                <div>
                    <h5 style={{display: "inline-block", marginRight: "15px", marginTop: "50px"}}>Choose a Sprint to View:</h5>
                    <div className="classChoice" style={{display: "inline-block", position: "relative", top: "27px"}}>
                        <SelectField
                            name="sprint"
                            value={sprint && sprint.name}
                            // onChange={(e) => handleSprintDropdownChange(e, classObject._id)}
                            iconStyle={{paddingLeft: "22px", fill: "rgba(0, 0, 0, 0.87)", marginTop: "-7px", marginRight: "3px"}}
                            style={{borderRadius: "5px", backgroundColor: "#e8e8e8", paddingLeft: "12px", height: "32px", width: "200px"}}
                            labelStyle={{color: "rgba(0, 0, 0, 0.87)", marginTop: "-7px"}}
                            underlineStyle={{border: "none"}}
                        >
                            {mapClassSprintOptions(classSprints, classObject._id)}
                        </SelectField>
                    </div>
                    <h5 style={{marginTop: "0px"}}>Students will receive a report of anonymous reviews from the assignments below.</h5>
                    <div className="greySprintBarItems" style={greySprintBarStyle}>
                        {getMappedSprintAssignments(filteredAssignments)}
                    </div>
                    <button className="actionButton" style={{marginRight: "20px"}} onClick={() => setClassSprintAndRedirect(classObject)}>
                        Add sprint
                    </button>
                    <button
                        disabled={!hasSelectedSprint}
                        className="actionButton"
                        style={{marginRight: "20px"}}
                        onClick={() => {
                            if (!hasSelectedSprint) return;
                            releaseSprint(sprint._id, classObject._id, sprints, teacherClasses);
                        }}
                    >
                        Release report
                    </button>
                    <button
                        disabled={!hasSelectedSprint}
                        className="actionButton"
                        onClick={() => {
                            if (!hasSelectedSprint) return;
                            setShowDialog(true);
                        }}
                    >
                        Delete sprint
                    </button>
                    <Dialog open={showDialog} onRequestClose={() => setShowDialog(false)}>
                        <div>
                            <h3>Are you sure you want to delete this sprint?</h3>
                            <div style={{display: "flex", justifyContent: "flex-end", padding: "20px 10px", gap: '24px'}}>
                                <button onClick={() => setShowDialog(false)} className="actionButton">Cancel</button>
                                <button
                                    disabled={!hasSelectedSprint}
                                    className="actionButton"
                                    onClick={() => {
                                        if (!hasSelectedSprint) return;
                                        deleteSprint(sprint._id, sprints, teacherClasses, assignments, teacherEvaluations);
                                    }}
                                >
                                    Delete sprint
                                </button>
                            </div>
                        </div>
                    </Dialog>
                </div>
                :
                <div>
                    <button className="actionButton" style={{marginTop: "50px"}} onClick={() => setClassSprintAndRedirect(classObject)}>
                        Add sprint
                    </button>
                </div>
            }
            {sprint &&
                <div>
                    <h3>Assignments for Sprint <span style={{color: "#ef6a6e"}}>{sprint.name}</span></h3>
                    <div className="tiles">
                        {getMappedAssignments(filteredAssignments, classObject)}
                    </div>
                    <p>{message}</p>
                    <button onClick={() => setClassAssignmentNewAndRedirect(classObject)} className="actionButton">
                        Add assignment
                    </button>
                </div>
            }
            {releasedClassSprints.length > 0 &&
                <div>
                    <div>
                        <h3>Sprint Reports</h3>
                        <div className="tiles">
                            {getMappedReports(classObject, releasedClassSprints)}
                        </div>
                    </div>
                    <div>
                        <h3>Sprint Grades</h3>
                        <div className="tiles">
                            {getMappedGrades(classObject, releasedClassSprints)}
                        </div>
                    </div>
                </div>
            } 
        </div>
    );
}
const mapDispatchToProps = {
  clearRequest,
  deleteSprint,
  denyRequest,
  getPossibleClasses,
  getRequests,
  getSchool,
  getSprintEvaluations,
  getSprintGrades,
  getSprints,
  getTeacherAssignments,
  getTeacherClasses,
  getTeacherEvaluations,
  getTeacherStudents,
  grantRequest,
  releaseSprint,
  releaseStudentReviewEvaluations,
  setAssignment,
  setClass,
  setClassEvalsSprintAndAssignments,
  setClassIndex,
  setCurrentSprint,
  setLoadingAssets,
  setSprint,
};
export default connect((state) => state.root, mapDispatchToProps)(Teacher);
